/* ============================================================
   La Nani — cardul de activitate din colțul de jos

   Ce face: la câteva secunde după ce omul intră pe pagină, apare
   jos-stânga un card de forma „Andreea M. din Cluj-Napoca — a comandat
   Lenjerie DELUXE…, acum 7 minute". Stă câteva secunde, pleacă, revine
   după o pauză, de cel mult șase ori pe vizită.

   ────────────────────────────────────────────────────────────
   CITEȘTE ASTA ÎNAINTE SĂ SCHIMBI CEVA

   Produsele sunt reale — titlul, poza și linkul vin din magazin.
   NUMELE, ORAȘUL ȘI MINUTELE SUNT INVENTATE. Cardul spune despre o
   comandă care nu s-a întâmplat.

   Google Merchant Center pune notificările de cumpărare inventate la
   „Misrepresentation", adică fix motivul pentru care magazinul a fost
   suspendat. Riscul e real și e al proprietarului, care l-a acceptat
   cerând funcția.

   Ca să oprești tot, fără să scoți nimic din pagină:
       var PORNIT = false;
   Nu mai trebuie schimbat nimic altundeva.
   ────────────────────────────────────────────────────────────

   Vezi snippets/ln-dovada.liquid și assets/la-nani-dovada.css.
   ============================================================ */
(function () {
  'use strict';

  var PORNIT = true;

  var PRIMA_APARITIE = 8000;   /* cât așteptăm după ce s-a încărcat pagina */
  var CAT_STA = 6500;          /* cât rămâne pe ecran un card */
  var PAUZA_MIN = 25000;       /* pauza dintre două carduri */
  var PAUZA_MAX = 50000;
  var CATE_MAX = 6;            /* câte carduri, cel mult, pe vizită */
  var CHEIE_INCHIS = 'lnDovadaInchis';

  /* Prenume românești, mai multe feminine decât masculine: lenjeria de pat
     se cumpără majoritar de femei. Inițiala de familie vine separat, ca să
     nu se repete aceleași combinații. */
  var PRENUME = [
    'Andreea', 'Maria', 'Elena', 'Ioana', 'Alexandra', 'Cristina', 'Gabriela',
    'Daniela', 'Mihaela', 'Roxana', 'Simona', 'Alina', 'Raluca', 'Bianca',
    'Denisa', 'Larisa', 'Georgiana', 'Ramona', 'Nicoleta', 'Camelia',
    'Adriana', 'Monica', 'Diana', 'Carmen', 'Anca', 'Oana', 'Lavinia',
    'Iulia', 'Teodora', 'Corina', 'Mirela', 'Claudia', 'Loredana', 'Aurora',
    'Marius', 'Andrei', 'Cătălin', 'Bogdan', 'Florin', 'Ionuț', 'Vlad',
    'Sorin', 'Adrian', 'Răzvan', 'Cristian', 'Daniel'
  ];

  var INITIALE = ['A.', 'B.', 'C.', 'D.', 'F.', 'G.', 'I.', 'L.', 'M.', 'N.',
                  'P.', 'R.', 'S.', 'T.', 'V.'];

  var ORASE = [
    'București', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Brașov',
    'Craiova', 'Galați', 'Oradea', 'Ploiești', 'Sibiu', 'Bacău', 'Arad',
    'Pitești', 'Târgu Mureș', 'Baia Mare', 'Buzău', 'Botoșani', 'Satu Mare',
    'Râmnicu Vâlcea', 'Suceava', 'Piatra Neamț', 'Alba Iulia', 'Deva',
    'Focșani', 'Târgoviște', 'Tulcea', 'Bistrița', 'Reghin', 'Zalău'
  ];

  var gazda, poza, cine, ce, cand, leg, inchide;
  var produse = [];
  var aratate = 0;
  var ceas = null;
  var ceasAscundere = null;
  var oprit = false;

  function intreg(min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  function unul(lista) {
    return lista[Math.floor(Math.random() * lista.length)];
  }

  /* ---------- distanța față de bara sticky ----------
     Bara „Comandă acum" e pe z-index 50, cardul pe 49. Dacă s-ar suprapune,
     cardul ar sta dedesubt și n-ar mai fi vizibil. Îl ridicăm deasupra ei
     exact cu înălțimea barei, și numai cât timp bara chiar se vede. */
  /* Bara „Comandă acum" apare abia dupa ce omul a derulat de pe butonul
     principal. Cardul se leaga de ea: apare numai cat timp bara se vede si
     sta deasupra ei. Asa nu acopera niciodata un buton — nici pe cel din
     pagina, nici pe cel lipicios. */
  function baraVizibila() {
    var bara = document.querySelector('[data-ln-sticky]');
    return !!(bara &&
              bara.classList.contains('show') &&
              !bara.classList.contains('atbottom'));
  }

  /* ---------- stocul afisat pe pagina ----------

     Randul „Mai sunt doar N bucati pe stoc" apare in doua locuri: sub
     butonul din pagina si sub cel din bara de jos. Amandoua pornesc de la
     acelasi numar, calculat in Liquid din id-ul produsului (4-9).

     La fiecare card de comanda care apare pe ecran, numarul scade cu unu,
     in ambele locuri deodata. Nu coboara sub 1, iar cand ajunge la 1
     cardurile se opresc de tot: un magazin care anunta comenzi cu o
     singura bucata pe stoc se contrazice singur.

     Umblam pe nodurile de text, nu pe innerHTML: randul contine si un
     element decorativ, si nu vrem sa-l rescriem la fiecare scadere. */
  function randuriStoc() {
    return document.querySelectorAll('.scarcity');
  }

  function stocCurent() {
    var e = randuriStoc()[0];
    if (!e) return null;
    var m = (e.textContent || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function scadeStoc() {
    var n = stocCurent();
    if (n === null) return;
    var nou = n - 1;
    if (nou < 1) nou = 1;
    if (nou === n) return;
    [].forEach.call(randuriStoc(), function (rand) {
      [].forEach.call(rand.childNodes, function (nod) {
        if (nod.nodeType === 3 && /\d/.test(nod.nodeValue)) {
          nod.nodeValue = nod.nodeValue.replace(/\d+/, nou);
        }
      });
    });
  }

  function potrivesteInaltimea() {
    if (!gazda) return;
    var bara = document.querySelector('[data-ln-sticky]');
    var jos = baraVizibila() ? bara.getBoundingClientRect().height : 0;
    gazda.style.setProperty('--ln-dovada-jos', jos + 'px');
  }

  function urmaresteBara() {
    var bara = document.querySelector('[data-ln-sticky]');
    if (!bara || typeof MutationObserver !== 'function') return;
    /* Bara își schimbă doar clasa, la derulare. Ne uităm exact la atât —
       e mai ieftin decât încă un ascultător de scroll. */
    new MutationObserver(function () {
      potrivesteInaltimea();
      if (oprit || aratate >= CATE_MAX) return;
      if (baraVizibila()) {
        /* daca nu e deja unul pe ecran, programam urmatorul */
        if (gazda.hidden) programeaza(intreg(1200, 2600));
      } else {
        clearTimeout(ceas);
        ascunde();
      }
    }).observe(bara, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- textul unui card ---------- */
  function compune() {
    var p = unul(produse);

    cine.textContent = unul(PRENUME) + ' ' + unul(INITIALE) + ' din ' + unul(ORASE);
    ce.textContent = 'a comandat ' + p.titlu;
    cand.textContent = 'acum';

    if (p.poza) {
      poza.src = p.poza;
    } else {
      poza.removeAttribute('src');
    }
    leg.href = p.url;
  }

  /* ---------- apariție și dispariție ---------- */
  function ascunde() {
    gazda.classList.remove('ln-dovada--intra');
    /* îl scoatem din pagină abia după ce s-a stins, ca tranziția să se vadă */
    clearTimeout(ceasAscundere);
    ceasAscundere = setTimeout(function () {
      gazda.hidden = true;
    }, 700);
  }

  function arata() {
    if (oprit || aratate >= CATE_MAX) return;
    /* Bara nu se vede inca: nu aratam nimic si nu consumam un card.
       `urmaresteBara` ne cheama inapoi in clipa in care apare. */
    if (!baraVizibila()) { clearTimeout(ceas); return; }

    /* Ultima bucata: nu mai anuntam comenzi. */
    var stoc = stocCurent();
    if (stoc !== null && stoc <= 1) { oprit = true; clearTimeout(ceas); return; }
    if (document.visibilityState === 'hidden') {
      /* Într-o filă ascunsă cardul s-ar consuma degeaba. Amânăm până
         se întoarce omul — `visibilitychange` reprogramează. */
      return;
    }

    compune();
    clearTimeout(ceasAscundere);
    gazda.hidden = false;
    potrivesteInaltimea();

    /* O pauză între `hidden = false` și clasa care pornește tranziția,
       altfel browserul le pune pe amândouă în același calcul și cardul
       apare dintr-o dată, fără mișcare.

       Nu `requestAnimationFrame`: într-o filă care nu e în față browserul
       nu mai rulează cadre, iar clasa ar rămâne neadăugată la nesfârșit —
       cardul ar sta în pagină, invizibil, până la reîncărcare. Un
       `setTimeout` se execută oricum. */
    setTimeout(function () {
      gazda.classList.add('ln-dovada--intra');
    }, 20);

    aratate++;
    scadeStoc();

    setTimeout(ascunde, CAT_STA);
    if (aratate < CATE_MAX) {
      programeaza(CAT_STA + intreg(PAUZA_MIN, PAUZA_MAX));
    }
  }

  function programeaza(ms) {
    clearTimeout(ceas);
    ceas = setTimeout(arata, ms);
  }

  function opreste(pentruToataVizita) {
    oprit = true;
    clearTimeout(ceas);
    ascunde();
    if (pentruToataVizita) {
      try {
        sessionStorage.setItem(CHEIE_INCHIS, '1');
      } catch (e) {
        /* mod privat sau cookie-uri blocate: rămâne oprit doar pe pagina asta */
      }
    }
  }

  function inchisDeja() {
    try {
      return sessionStorage.getItem(CHEIE_INCHIS) === '1';
    } catch (e) {
      return false;
    }
  }

  function porneste() {
    if (!PORNIT || inchisDeja()) return;

    gazda = document.querySelector('[data-ln-dovada]');
    var sursa = document.querySelector('[data-ln-dovada-produse]');
    if (!gazda || !sursa) return;

    try {
      produse = JSON.parse(sursa.textContent) || [];
    } catch (e) {
      return;
    }
    if (!produse.length) return;

    poza = gazda.querySelector('[data-ln-dovada-poza]');
    cine = gazda.querySelector('[data-ln-dovada-cine]');
    ce = gazda.querySelector('[data-ln-dovada-ce]');
    cand = gazda.querySelector('[data-ln-dovada-cand]');
    leg = gazda.querySelector('[data-ln-dovada-leg]');
    inchide = gazda.querySelector('[data-ln-dovada-x]');
    if (!poza || !cine || !ce || !cand || !leg || !inchide) return;

    /* „×" înseamnă „nu mă mai deranja" — pentru toată vizita, nu doar
       pentru cardul ăsta. */
    inchide.addEventListener('click', function () {
      opreste(true);
    });

    urmaresteBara();
    window.addEventListener('resize', potrivesteInaltimea);

    document.addEventListener('visibilitychange', function () {
      if (oprit) return;
      if (document.visibilityState === 'hidden') {
        clearTimeout(ceas);
        ascunde();
      } else if (aratate < CATE_MAX) {
        programeaza(intreg(4000, 9000));
      }
    });

    programeaza(PRIMA_APARITIE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }
})();
